import { render } from "./ItemInPrefab.vue?vue&type=template&id=617a6cec&scoped=true"
import script from "./ItemInPrefab.vue?vue&type=script&lang=js"
export * from "./ItemInPrefab.vue?vue&type=script&lang=js"

import "./ItemInPrefab.vue?vue&type=style&index=0&id=617a6cec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617a6cec"]])

export default __exports__